import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base API URL from environment variables
const apiUrl = process.env.REACT_APP_API_URL;

// Thunk: Fetch all userLevels
export const fetchuserLevels = createAsyncThunk(
  "userLevels/fetchuserLevels",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/UserLevels/`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
        console.log("Get User Levels", response.data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || "Failed to fetch user levels"
      );
    }
  }
);

// Thunk: Get a userLevel by ID
export const getUserLevelById = createAsyncThunk(
  "userLevels/getUserLevelById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${apiUrl}/UserLevels/${id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data ||
          error.message ||
          `Failed to fetch user level with ID: ${id}`
      );
    }
  }
);

// Slice for userLevels
const userLevelsSlice = createSlice({
  name: "userLevels",
  initialState: {
    userLevels: [],
    selectedUserLevel: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchuserLevels.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchuserLevels.fulfilled, (state, action) => {
        state.loading = false;
        state.userLevels = action.payload;
      })
      .addCase(fetchuserLevels.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getUserLevelById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserLevelById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedUserLevel = action.payload; // Store the user level retrieved by ID
      })
      .addCase(getUserLevelById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectUserLevels = (state) => state.userLevels;
export const selectUserLevelsLoading = (state) => state.userLevels.loading;
export const selectUserLevelsError = (state) => state.userLevels.error;
export const selectSelectedUserLevel = (state) => state.userLevels.selectedUserLevel;

export default userLevelsSlice.reducer;